<div class="pre-qual-container">
  <h1 class="heading">{{ "ELIGIBILITY_PAGE.TITLE" | translate : { cardName: cardName } }}</h1>

  <rbc-box-container class="box-container" [background]="'highlight'" outline="border">
    <rbc-card-art class="chosen-card-art" size="m" [locale]="locale" [token]="productCode.toLowerCase()"></rbc-card-art>
    <div class="chosen-card-info">
      <p class="chosen-card-info__title">{{ "ELIGIBILITY_PAGE.CHOSEN_TITLE" | translate }}</p>
      <p class="chosen-card-info__name">{{ cardName }}</p>
    </div>
  </rbc-box-container>
  <p class="sub-heading">
    <span>{{ "ELIGIBILITY_PAGE.SUBTITLE_PT1" | translate }}</span
    ><span class="sub-heading-bold">{{ "ELIGIBILITY_PAGE.SUBTITLE_PT2" | translate }}</span
    ><span>{{ "ELIGIBILITY_PAGE.SUBTITLE_PT3" | translate }}</span>
  </p>
  <div class="container requirements-header">
    <div class="left-block">
      <p rbcTextStyle kind="heading" size="xs" class="rbc-mb-xs">{{ "ELIGIBILITY_PAGE.BUSINESS_REQS" | translate }}</p>
      <rbc-list kind="symbol" density="default" spacingBetweenItems="4xs">
        <rbc-list-item>{{ "ELIGIBILITY_PAGE.BUS_REQ_1" | translate }}</rbc-list-item>
        <rbc-list-item>{{ "ELIGIBILITY_PAGE.BUS_REQ_2" | translate }}</rbc-list-item>
        <rbc-list-item>{{ "ELIGIBILITY_PAGE.BUS_REQ_3" | translate }}</rbc-list-item>
        <rbc-list-item>{{ "ELIGIBILITY_PAGE.BUS_REQ_4" | translate }}</rbc-list-item>
      </rbc-list>
    </div>
    <div class="right-block">
      <p rbcTextStyle kind="heading" size="xs" class="rbc-mb-xs">{{ "ELIGIBILITY_PAGE.PERSONAL_REQS" | translate }}</p>
      <rbc-list kind="symbol" density="default" spacingBetweenItems="4xs">
        <rbc-list-item>{{ "ELIGIBILITY_PAGE.PERSONAL_REQ_1" | translate }}</rbc-list-item>
        <rbc-list-item
          ><rbc-tooltip
            [help]="true"
            [blur]="true"
            [small]="true"
            [label]="'ELIGIBILITY_PAGE.PERSONAL_REQ_2' | translate"
            [tooltipAriaLabel]="'ELIGIBILITY_PAGE.AGE_OF_MAJORITY_TOOLTIP_INFO' | translate"
            [closeIconAriaLabel]="'Close tooltip'"
            data-dig-id=""
          >
            <rbc-tooltip-content>
              <div
                [innerHTML]="'ELIGIBILITY_PAGE.AGE_OF_MAJORITY_TOOLTIP' | translate"
                [attr.aria-label]="'ELIGIBILITY_PAGE.AGE_OF_MAJORITY_ACCESSIBILITY' | translate"
              ></div>
            </rbc-tooltip-content> </rbc-tooltip
        ></rbc-list-item>
        <rbc-list-item>{{ "ELIGIBILITY_PAGE.PERSONAL_REQ_3" | translate }}</rbc-list-item>
      </rbc-list>
    </div>
  </div>
  <ng-container *ngIf="isPremiumCard">
    <p class="sub-heading">
      <span>{{ "ELIGIBILITY_PAGE.INCOME_REQS_PT1" | translate }}</span
      ><span class="sub-heading-bold">{{ "ELIGIBILITY_PAGE.INCOME_REQS_PT2" | translate }}</span
      ><span>{{ "ELIGIBILITY_PAGE.INCOME_REQS_PT3" | translate }}</span>
    </p>
    <div class="rbc-mb-xs">
      <p rbcTextStyle kind="heading" size="xs" class="rbc-mb-xs">
        {{ "ELIGIBILITY_PAGE.INCOME_REQUIREMENTS" | translate }}
      </p>
      <rbc-list kind="symbol" density="default" spacingBetweenItems="4xs">
        <rbc-list-item>{{ "ELIGIBILITY_PAGE." + productCode + "_INCOME_REQ_1" | translate }}</rbc-list-item>
        <rbc-list-item>{{ "ELIGIBILITY_PAGE." + productCode + "_INCOME_REQ_2" | translate }}</rbc-list-item>
        <rbc-list-item>{{ "ELIGIBILITY_PAGE." + productCode + "_INCOME_REQ_3" | translate }}</rbc-list-item>
        <rbc-list-item>{{ "ELIGIBILITY_PAGE." + productCode + "_INCOME_REQ_4" | translate }}</rbc-list-item>
        <rbc-list-item>{{ "ELIGIBILITY_PAGE." + productCode + "_INCOME_REQ_5" | translate }}</rbc-list-item>
      </rbc-list>
    </div>
    <p rbcTextStyle kind="paragraph" size="sm" class="rbc-mb-m">
      <em>{{ "ELIGIBILITY_PAGE.PREMIUM_CARD_NOTICE" | translate }}</em>
    </p>
  </ng-container>
  <rbc-divider class="rbc-mb-m"></rbc-divider>
  <p rbcTextStyle kind="paragraph">
    {{ "ELIGIBILITY_PAGE.APPLY_OTHER_WAY" | translate }}<a target="_blank" href="tel:+18668262473">1 (866) 826-2473</a>.
  </p>

  <div class="westjet-requirement-container rbc-mt-xl" *ngIf="isWestJet">
    <rbc-icon class="flag-icon" name="flag" size="md" [fromMap]="false"></rbc-icon>
    <div>
      <p class="westjet-requirement-title">{{ "ELIGIBILITY_PAGE.WESTJET_REQUIREMENT_TITLE" | translate }}</p>
      <p class="westjet-requirement-content">{{ "ELIGIBILITY_PAGE.WESTJET_CONTENT" | translate }}</p>
      <p>
        {{ "ELIGIBILITY_PAGE.WESTJET_SIGNUP" | translate }}
        <rbc-cta-text (click)="goToWestjetSignup()" elementType="button" type="button" density="default">
          {{ "ELIGIBILITY_PAGE.WESTJET_SIGNUP_CTA" | translate }}
          <rbc-icon-button icon="external-link" iconSize="sm" background="none"> </rbc-icon-button>
        </rbc-cta-text>
      </p>
    </div>
  </div>
</div>
